/* PreNumbers Financial Builder — Other Variables (reskinned).
   REPLACES: src/components/FinancialBuilder/Misc/OtherVariblesCost.jsx
   Rendered inside the Fine-tune modal. Logic unchanged; renderFields prop kept
   for the PSBB variant. */

import { useState, useContext } from 'react';

import { FinancialBuilderContext } from '../FinancialBuilderPage.jsx';
import { industryDetails, otherVariablesCostRenderFields } from '../../constants.jsx';
import { genericPOSTDatabaseCall } from '../../helperFunctions.jsx';
import { renderFbField, FbIcons } from '../fbUI.jsx';

const { SaveOutlined } = FbIcons;

async function saveCompanyToDatabase(company) { return genericPOSTDatabaseCall('/api/fb/saveCompanyInfo', { company }, 'company info'); }

function OtherVariablesCost({ contextToUse, renderFields }) {
  const { companySelected, messageApi, setCompanySelected } = useContext(contextToUse || FinancialBuilderContext);
  const [saving, setSaving] = useState(false);
  renderFields = renderFields || otherVariablesCostRenderFields;

  const handleSave = async () => {
    setSaving(true); messageApi.loading('Saving company info...', 0);
    try {
      await saveCompanyToDatabase({ ...companySelected, id: companySelected.fb_id !== undefined ? companySelected.fb_id : companySelected.id });
      messageApi.destroy(); messageApi.success('Company info saved successfully');
    } catch (e) { console.error('Error saving company info:', e); messageApi.destroy(); messageApi.error('Failed to save company info'); }
    setSaving(false);
  };

  const handleInputChange = (event, company, key) => { setCompanySelected((prev) => ({ ...prev, [key]: event.target.value })); };
  const handleInputBlur = (event, company, key, field) => {
    let newValue = event.target.value;
    const fallback = () => (industryDetails[company.industry] ? industryDetails[company.industry][key] : field.default || '');
    if (field.regexCondition && field.errorMessage && !field.regexCondition.test(newValue)) { messageApi.error(field.errorMessage); newValue = fallback(); }
    if (newValue === '') { messageApi.error('This field cannot be empty'); newValue = fallback(); }
    setCompanySelected((prev) => ({ ...prev, [key]: newValue }));
  };

  return (
    <div className="pn-modal-embed">
      <div className="pn-fieldset">
        <div className="pn-fieldset-title">Other variables</div>
        <div className="pn-fields">{renderFields.map((f) => renderFbField(f, companySelected, handleInputChange, true, handleInputBlur))}</div>
      </div>
      <div className="pn-editor-foot"><div className="sp" />
        <button type="button" className="pn-btn pn-btn-accent" disabled={saving} onClick={handleSave}><SaveOutlined /> Save</button>
      </div>
    </div>
  );
}

export default OtherVariablesCost;
